<template>
    <div class="footer">
        <div class="bigBox">
            <p>Copyright © 2020 HOLIDAY MUSEUM Inc. All rights reserved. © 2020 <a href="https://beian.miit.gov.cn/" target="_blank" class="beian">京ICP备18003216号-1</a></p>
            
            <ul class="hyperlinks">
                
                <!-- <li>预留快速链接</li>
                <li>预留快速链接</li>
                <li>预留快速链接</li>
                <li>预留快速链接</li> -->
            </ul>
        </div>
    </div>
</template>

<script type="text/ecmascript-6">
export default {
 components: {},
 props: {},
 data () {
 return {
 };
 },
 watch: {},
 computed: {},
 methods: {},
 mounted () {}
};
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue